import { Button } from "@mui/material";
import { ArrowLeftCircle, ArrowRightCircle } from "react-feather";

import { ModalModule } from "../Modal";
import { CollateralTable } from "./CollateralTable";
import { CollateralImages } from "./CollateralImages/CollateralImages";

export const FormStepCollateral = ({ useFetchInit }) => {
  const { globalStates, Actions } = useFetchInit;

  const { stepApplilication, showSection } = globalStates;
  const { handleClickReturnStep, handleClickNextStep } = Actions;

  const isHome = showSection === "HOME";
  const isImage = showSection === "IMAGE";

  return (
    <div className="content">
      {isHome && (
        <>
          <CollateralTable useFetchInit={useFetchInit} />
          <ModalModule useFetchInit={useFetchInit} />

          <div className="text-center">
            {stepApplilication !== 0 && (
              <Button
                startIcon={<ArrowLeftCircle />}
                variant="contained"
                type="button"
                className="btn-round"
                color="warning"
                onClick={handleClickReturnStep}
                sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
              >
                Volver
              </Button>
            )}

            <Button
              endIcon={<ArrowRightCircle />}
              variant="contained"
              type="button"
              className="btn-round"
              color="primary"
              sx={{ marginTop: 2, marginRight: 1, marginLeft: 1 }}
              onClick={handleClickNextStep}
            >
              {stepApplilication === 4 ? "Finalizar" : "Continuar"}
            </Button>
          </div>
        </>
      )}

      {isImage && <CollateralImages useFetchInit={useFetchInit} />}
    </div>
  );
};
